import { lazyLoad } from 'utils/loadable';
import { LoadingIndicator } from 'app/components/LoadingIndicator';

export const New = lazyLoad(
  () => import('./index'),
  module => module.New,
  {
    fallback: <LoadingIndicator />,
  },
);
